//api
import SystemApi from "api/system"
import moment from "moment"

/*HELPERS*/
import { getValue } from 'helpers/Objects'
import { IsObject } from "helpers/ValueTests"

export default class Settings {
    constructor(core) {
        this.core = core
    }

    LoadGlobalSettings = async () => {
        const { DataStatus, updateStore } = this.core

        const settings = window.SETTINGS

        if (settings) {
            const dataTransaction = DataStatus.createTransaction("settings")

            const { lang = "ru" } = settings

            moment.locale(lang)

            updateStore(
                {
                    settings: { $set: settings },
                    ...dataTransaction.done(),
                },
                "Settings::LoadGlobalSettings"
            )

            return true
        } else {
            let lang = "ru"
            if (window.localStorage.getItem("lang")) lang = window.localStorage.getItem("lang")

            const { doctor_id } = window

            const request = DataStatus.createRequest(
                [SystemApi.GetSettings, { lang, params: {doctor_id}}],
                "settings"
            )

            await request
                .onComplete(({ lang = "ru" }) => {
                    moment.locale(lang)
                })
                .start({
                    logName: "Settings::LoadGlobalSettings",
                    debug: true,
                })
        }
    }

    getParam(name, def) {
        return getValue(
            this.core.store.getState().settings,
            name,
            def
        )
    }

    Set = (settings) => {
        if (IsObject(settings)) {
            this.core.updateStore({settings: { $set: settings }})
        }
    }
}
